<template>
  <div>
    <v-card class="templateCard elevation-5">
      <v-card-text>
        <v-layout justify-space-between align-start wrap>
          <CardHeader
            :initialProductName="OTPDetails.productName"
            :initialProductPrice="OTPDetails.productPrice"
            :currency="OTPDetails.currency"
          />
          <v-flex
            :xs10="templateConfig.theme === 'Template-A'"
            :md9="templateConfig.theme === 'Template-A'"
            :xs12="templateConfig.theme === 'Template-B'"
          >
            <div style="overflow: hidden">
              <transition mode="out-in">
                <KeepAlive :max="3">
                  <Component :is="OTPDetails.component" />
                </KeepAlive>
              </transition>
            </div>
          </v-flex>
          <!-- Vertical stepper start -->
          <v-flex
            :xs2="templateConfig.theme === 'Template-A'"
            :md3="templateConfig.theme === 'Template-A'"
            v-if="
              templateConfig.theme === 'Template-A' ||
              templateConfig.theme === 'Template-B'
            "
          >
            <CustomStepper
              :model="OTPDetails.step"
              :steps="3"
              :isVertical="templateConfig.theme === 'Template-A'"
            />
            <PrimaryDisclaimer
              class="primaryDisc"
              v-if="templateConfig.theme === 'Template-B'"
            >
              <div v-html="primaryDisclaimerText"></div>
              <div v-html="generalDisclaimerText"></div>
            </PrimaryDisclaimer>
            <template
              v-if="
                !merchantConfig.configs.HideTermsAndConditions &&
                templateConfig.theme === 'Template-B'
              "
            >
              <div class="cardFooter">
                <Terms />
              </div>
            </template>
          </v-flex>
          <!-- Vertical stepper end -->
        </v-layout>
      </v-card-text>
    </v-card>
    <PrimaryDisclaimer
      class="primaryDisc"
      v-if="templateConfig.theme === 'Template-A'"
    >
      <div v-html="primaryDisclaimerText"></div>
      <div v-html="generalDisclaimerText"></div>
    </PrimaryDisclaimer>
  </div>
</template>

<script>
//1.General imports.
import { mapState, mapMutations } from 'vuex';
import Terms from '../Shared/components/Terms/terms.vue';

//2.shared comp. imports.
import CardHeader from '../Shared/components/CardHeader.vue';
import CustomStepper from '../Shared/components/custom-stepper.vue';
import PrimaryDisclaimer from '../Shared/components/Disclaimer.vue';
import ExpiredSession from '../Shared/components/ExpiredSession.vue';

//3. OTP flow components imports.
import OTPInit from './stepper-content/OTP-init.vue';
import OTPPincode from './stepper-content/OTP-pincode.vue';
import OTPSuccess from './stepper-content/OTP-success.vue';
import OTPPending from './stepper-content/OTP-pending.vue';
import OTPFailure from './stepper-content/OTP-failure.vue';
import OTPInstructions from './stepper-content/OTP-instructions.vue';

export default {
  props: {
    isRedirectionFlow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['merchantConfig', 'templateConfig', 'OTPDetails']),
    primaryDisclaimerText() {
      switch (this.OTPDetails.component) {
        case 'OTPInit':
          //No need for $replacePlaceholders plugin function.
          return this.merchantConfig.texts.initPrimaryDisclaimer;
        case 'OTPPincode':
          //No need for $replacePlaceholders plugin function.
          return this.merchantConfig.texts.pinCodePrimaryDislcaimer;
        case 'OTPSuccess':
          //No need for $replacePlaceholders plugin function.
          return this.merchantConfig.texts.successPrimaryDisclaimer;
        case 'OTPFailure':
          //No need for $replacePlaceholders plugin function.
          return this.merchantConfig.texts.failurePrimaryDisclaimer;
        case 'OTPInstructions':
          //No need for $replacePlaceholders plugin function.
          return this.merchantConfig.texts.instructionPrimaryDisclaimer;
        default:
          return '';
      }
    },
    generalDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.generalDisclaimer;
    },
  },
  components: {
    CardHeader,
    CustomStepper,
    PrimaryDisclaimer,
    Terms,
    OTPInit,
    OTPPincode,
    OTPSuccess,
    OTPPending,
    OTPFailure,
    OTPInstructions,
    ExpiredSession
  },
  methods: {
    ...mapMutations(['setOTPDetails', 'setMerchantConfig']),
    injectScript(url){
      const script = document.createElement('script');
      script.src = url;
      document.head.appendChild(script);
    }
  },
  async created() {
    this.$http.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 401) {
          this.setOTPDetails({
            step: 3,
            component: 'ExpiredSession',
            operationStatusCode: 401,
          });
        }
        return Promise.reject(error);
      }
    );

      let response = await this.$http.get(`/otp/GetOneTimePaymentDetails?merchantId=${this.merchantConfig.merchantId}`);
    /*========= response object Template ========== */
    // let response = {
    //   data: {
    //     productCatalogName: 'HETest',
    //     productName: '100 Points',
    //     productPrice: null,
    //     productId: '100Points',
    //     orderInfo: 'order123',
    //     overrideProductName: null,
    //     isDynamicPayment: false,
    //     additionalInfo: '{"WalletPinCode":" sarah"}',
    //     customerContactInfo: {
    //       firstName: null,
    //       lastName: null,
    //       email: null,
    //       accountNumber: null,
    //       message: '',
    //     },
    //     message:
    //       'hesham20127024098360201100PointsHETest1order123https://www.my-redirect.com',
    //     merchantPublicKey: null,
    //     merchantTemplateKey: 'hesham',
    //     redirectUrl: 'https://www.my-redirect.com',
    //     language: 1,
    //     allowSimulation: false,
    //     msisdn: '',
    //     operatorCode: '',
    //     signature:
    //       '0oa70WuefiddqLjqlTlp:39b322bf03f780a3d4aed7b708768d845b2899475e9597b55009df5582df5cf9',
    //     isSilent: false,
    //   },
    // };
    /*============================================= */
      // add missing MSISDN and operator from cached values.
      this.injectScript(response.data.oneTimePaymentServiceClientUrl);

    let operatorCode = response.data.operatorCode
      ? response.data.operatorCode
      : localStorage.getItem('operatorCode');
    let msisdn = response.data.msisdn
      ? response.data.msisdn
      : localStorage.getItem('msisdn');
    this.setOTPDetails({
      ...response.data,
      msisdn,
      operatorCode,
    });

    //save additional fields values if any
    if (response.data.additionalInfo) {
      let additionalFieldsObj = JSON.parse(response.data.additionalInfo);
      let tempMerchantConfig = this.merchantConfig;
      tempMerchantConfig.fields.forEach((elem) => {
        let key = elem.key;
        key = key[0].toLowerCase() + key.slice(1);
        if (additionalFieldsObj[key]) {
          elem['value'] = additionalFieldsObj[key];
        }
      });
      this.setMerchantConfig(tempMerchantConfig);
    }

    //override country to be editable incase no operatorcode
    if (!response.data.operatorCode) {
      let tempMerchantConfig = this.merchantConfig;
      tempMerchantConfig.fields[0].isEditable = true;
      this.setMerchantConfig(tempMerchantConfig);
    }

    //set the step
    if (this.isRedirectionFlow) {
      if (this.$route.params.paymentStatus == 'error') {
        this.setOTPDetails({
          component: 'OTPFailure',
          step: 3,
          operationStatusCode: '51',
        });
      } else if (this.$route.params.paymentStatus == 'success') {
        this.setOTPDetails({ component: 'OTPSuccess', step: 3 });
      } else if (this.$route.params.paymentStatus == 'pending') {
        this.setOTPDetails({
          step: 3,
          component: 'OTPPending',
        });
      }
    } else {
      this.setOTPDetails({ step: 1, component: 'OTPInit' });
    }
  },
};
</script>
